<script>
import { mapActions } from 'vuex';
import axios from 'axios';
import { cloneDeep, result } from 'lodash';
import RbxRemoteCombobox from '@/shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '@/shared/reybex/RbxRemoteComboboxMultiple';
import validatorMixin from '@/mixins/validator';
import snackbarMixin from '@/mixins/snackbar';

export default {
  name: 'NoteDialog',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
  },
  mixins: [snackbarMixin, validatorMixin],
  props: {
    task: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  data() {
    return {
      visible: false,
      isLoading: false,
      rules: {
      },
      taskData: {},
      formData: {},
      currentUser: '',
    };
  },
  create() {

  },
  mounted() {
    this.taskData = cloneDeep(this.task);
    this.formData = this.taskData.notes;
    this.formData.push({ id: null, text: '', task: { id: this.task.id } });
    this.visible = true;

    const self = this;

    axios.get('/user', {
      params: {
        current: true,
      },
    })
      .then((response) => {
        console.log(response.data.email);
        self.currentUser = response.data.email;
        console.log(self.currentUser);
      })
      .catch((err) => {
        console.log(err);
      });
  },
  beforeDestroy() {
    this.visible = false;
  },
  methods: {
    ...mapActions('taskList', ['saveNotes']),
    submit(type) {
      if (!this.validateForm()) return false;

      this.isLoading = true;

      if (this.parentResource && this.parentResourceId) {
        this.formData[this.parentResource] = this.parentResourceId;
      }

      return this.saveNotes(this.formData)
        .then(({ data }) => {
          this.showSuccessMessage('Der Kommentar wurde gespeichert.');

          if (type === 'new') {
            this.formData = cloneDeep(this.baseFormData);
          } else {
            this.close();

            if (type === 'detail') {
              this.$router.push(`/note/${data.id}`);
            }
          }
        })
        .catch(({ response }) => {
          const message = result(response, 'data.data.error', 'Es ist ein Fehler aufgetreten.');
          this.showErrorMessage(message);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    close() {
      this.$emit('cancel');
    },
  },
};
</script>

<template>
  <v-dialog v-model="visible"
            persistent
            max-width="1000px">

    <v-card>
      <v-card-title class="title pa-3">
        Notizen bearbeiten
      </v-card-title>

      <v-card-text>

        <v-container grid-list-md class="pa-0">

          <div v-for="note in formData" :key="note.id">
            <v-layout v-if="!note.id" row wrap>
              <v-flex md12>
                <v-layout row wrap>
                  <v-flex md12>
                    <v-textarea
                      v-model="note.text"
                      label="Text"
                      class="caption"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </div>

          <div v-for="note in formData" :key="note.id">
            <v-layout row wrap>
              <v-flex md12>
                <v-layout v-if="note.id" row wrap>
                  <v-flex md8>
                    <v-textarea
                      v-model="note.text"
                      label="Text"
                      class="caption"
                      :disabled="note.createdBy != currentUser"
                    />
                  </v-flex>
                  <v-flex md4>
                    <v-text-field
                      v-model="note.createdBy"
                      label="Autor"
                      class="caption"
                      :disabled="true"
                    />
                    <v-text-field
                      v-model="note.dateCreated"
                      label="Erstellt am"
                      class="caption"
                      :disabled="true"
                    />
                  </v-flex>
                </v-layout>
                <!--<v-layout v-else row wrap>
                  <v-flex md12>
                    <v-textarea
                      v-model="note.text"
                      label="Text"
                      class="caption"
                    />
                  </v-flex>
                </v-layout>-->
              </v-flex>
            </v-layout>
          </div>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn @click.native="close"
               color="red"
               flat>
          Schließen
        </v-btn>

        <v-btn @click.native="submit"
               color="blue"
               :loading="isLoading"
               flat>
          Speichern
        </v-btn>

      </v-card-actions>
    </v-card>

  </v-dialog>
</template>
